import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow_right_top",
  "use": "icon-arrow_right_top-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow_right_top\">\r\n<path d=\"M7.50001 17.5L15.5 9.5V16.5C15.5 17.0515 15.9485 17.5 16.5 17.5C17.0516 17.5 17.5 17.0515 17.5 16.5V7.0112C17.5 6.45966 17.0516 6.01416 16.5 6.01416H7.00001C6.44846 6.01416 6.00001 6.45966 6.00001 7.0112C6.00001 7.56274 6.44846 8.00822 7.00001 8.00822H14L6.00001 16C5.6111 16.3889 5.61109 17.1111 6 17.5C6.38891 17.8889 7.1111 17.8889 7.50001 17.5Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol